export const PlatformTypesEnum = {
  ios: "ios",
  android: "android",
};

export const PlatformTypesMapping = {
  [PlatformTypesEnum.ios]: "iOS",
  [PlatformTypesEnum.android]: "Android",
};
